<div *ngIf="componentData" class="faq-container {{textStyle}}" [ngStyle]="{'background-color': backgroundColor}">
    <div class="faq-content-wrapper">
        <h2 class="heading-4 text-center">{{ translationRoot + '.title' | translate:useLocaleOverride }}</h2>
        <div *ngFor="let question of questions; trackBy: trackByFn" class="faq-row"
             [ngClass]="{'active': isExpanded(question.id)}">

            <h3 class="heading-3" (click)="toggleExpand(question.id)"><span translate="{{question.tag1}}" [useLocaleOverride]="useLocaleOverride"></span>
                <button class="faq-toggle icon-toggle" [attr.aria-label]="'cart.faq.toggle.answer'| translate:useLocaleOverride">
                    <i class="pull-right fa-solid fa-chevron-up rotate" [attr.aria-hidden]="!isExpanded(question.id)"
                       [ngClass]="{'down': isExpanded(question.id)}"></i>
                </button>
            </h3>
            <div class="faq-answer-container">
                <div class="faq-answer" [innerHTML]="question.tag2 | translate:useLocaleOverride"></div>
            </div>
        </div>
    </div>
</div>
